<span class="relative flex flex-col w-full h-full">
    <div class="p-8 pb-2 mb-0" mat-dialog-title>
        <span>
            <ng-container>
                <div class="absolute top-0 right-0 pt-4 pr-4">
                    <button (click)="close()" mat-icon-button [matTooltip]="'Loka'">
                        <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                    </button>
                </div>
            </ng-container>
            <div class="sm:flex xs:block w-100 border-b pb-[10px]">
                <div class="sm:flex-initial xs:block xs:max-w-100 sm:max-w-70pr">
                    <!-- Name -->
                    <div class="mt-3 text-2xl sm:text-4xl font-bold truncate w-100">Yfirlit bréfaútskrifta</div>
                </div>
            </div>
        </span>
    </div>
    <div class="p-8 pt-0 pb-0" mat-dialog-content>
        <ng-container>
            <div class="float-left xs:w-100 sm:w-40pr sm:border-none mb-2 pb-4 w-100">
                <section class="table-container mat-evaluation-z8" tabindex="0">
                    <table
                        matSort
                        (matSortChange)="sortData($event)"
                        mat-table
                        [dataSource]="displayedData"
                        class="w-[200%]"
                        style="overflow: auto; height: 10px"
                    >
                        <ng-container matColumnDef="loggnumer">
                            <th mat-sort-header="loggnumer" mat-header-cell *matHeaderCellDef>Skjalanúmer</th>
                            <td mat-cell *matCellDef="let element">{{element.loggnumer}}</td>
                        </ng-container>

                        <ng-container matColumnDef="sjodur">
                            <th mat-sort-header="sjodur" mat-header-cell *matHeaderCellDef>Sjóður</th>
                            <td mat-cell *matCellDef="let element">{{element.sjodur}}</td>
                        </ng-container>

                        <ng-container matColumnDef="dags">
                            <th mat-sort-header="dags" mat-header-cell *matHeaderCellDef>Dags</th>
                            <td mat-cell *matCellDef="let element">{{formatDate(element.dags)}}</td>
                        </ng-container>

                        <ng-container matColumnDef="breF_HEITI">
                            <th mat-sort-header="breF_HEITI" mat-header-cell *matHeaderCellDef>Titill</th>
                            <td mat-cell *matCellDef="let element">{{element.breF_HEITI}}</td>
                        </ng-container>

                        <ng-container matColumnDef="ktalas">
                            <th mat-sort-header="ktalas" mat-header-cell *matHeaderCellDef>Kennitala eiganda/viðtakanda</th>
                            <td mat-cell *matCellDef="let element">{{formatKennitala(element.ktalas)}}</td>
                        </ng-container>

                        <ng-container matColumnDef="nafns">
                            <th mat-sort-header="nafns" mat-header-cell *matHeaderCellDef>Nafn eiganda/viðtakanda</th>
                            <td mat-cell *matCellDef="let element">{{element.nafns}}</td>
                        </ng-container>

                        <ng-container matColumnDef="skjalid">
                            <th mat-sort-header="skjalid" mat-header-cell *matHeaderCellDef>Númer bréfs</th>
                            <td mat-cell *matCellDef="let element">{{element.skjalid}}</td>
                        </ng-container>

                        <ng-container matColumnDef="skjalid_hopur">
                            <th mat-sort-header="skjalid_hopur" mat-header-cell *matHeaderCellDef>Hópur</th>
                            <td mat-cell *matCellDef="let element">{{element.skjalid_hopur}}</td>
                        </ng-container>

                        <ng-container matColumnDef="notandi">
                            <th mat-sort-header="notandi" mat-header-cell *matHeaderCellDef>Notandi</th>
                            <td mat-cell *matCellDef="let element">{{element.notandi}}</td>
                        </ng-container>

                        <ng-container matColumnDef="bref">
                            <th mat-sort-header="bref" mat-header-cell *matHeaderCellDef>Bréf</th>
                            <td mat-cell *matCellDef="let element">{{element.bref}}</td>
                        </ng-container>

                        <ng-container matColumnDef="slod">
                            <th mat-sort-header="slod" mat-header-cell *matHeaderCellDef>Slóð</th>
                            <td mat-cell *matCellDef="let element">{{element.slod}}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="documentColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: documentColumns;"></tr>
                    </table>
                </section>
                <mat-paginator
                    #tablePaginator
                    class="justify-end"
                    showFirstLastButtons
                    [pageSize]="10"
                    [pageSizeOptions]="[10, 25, 50, 100]"
                >
                </mat-paginator>
            </div>
        </ng-container>
    </div>
</span>
